import { Provider } from 'react-redux';
import type { DataRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import type { AppStore } from './store';

interface AppProps {
  store: AppStore;
  router: DataRouter;
}

/** Application providers. Store and router are created by the caller (main.tsx or tests). */
export function App({ store, router }: AppProps) {
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}
